export const cogFuncPriorities = [
  { function: "dominant", short: "dom" },
  { function: "auxiliary", short: "aux" },
  { function: "tertiary", short: "ter" },
  { function: "inferior", short: "inf" },
];

export const cognitiveFunctions = [
  { function: "intuition", short: "n", color: "#66BB6A" },
  { function: "sensing", short: "s", color: "#FFB74D" },
  { function: "thinking", short: "t", color: "#4FC3F7" },
  { function: "feeling", short: "f", color: "#F06292" },
];

export const eightCogFuncs = [
  {
    function: "extraverted intuition",
    short: "ne",
  },
  {
    function: "introverted intuition",
    short: "ni",
  },
  {
    function: "extraverted sensing",
    short: "se",
  },
  {
    function: "introverted sensing",
    short: "si",
  },
  {
    function: "extraverted thinking",
    short: "te",
  },
  {
    function: "introverted thinking",
    short: "ti",
  },
  {
    function: "extraverted feeling",
    short: "fe",
  },
  {
    function: "introverted feeling",
    short: "fi",
  },
];

export const eiArr = ["E", "I"];
export const snArr = ["S", "N"];
export const tfArr = ["T", "F"];
export const jpArr = ["J", "P"];
export const cogFuncsArrs = [eiArr, snArr, tfArr, jpArr];

export const domAux = ["dominant", "auxiliary"];
export const terInf = ["tertiary", "inferior"];
export const domAuxTerInf = domAux.concat(terInf);

export const intSens = ["intuition", "sensing"];
export const thinkFeel = ["thinking", "feeling"];

export const modesData = [
  {
    title: "Cognitive Function Explorer",
    id: "cogfunc-explorer",
    enabled: true,
  },
  {
    title: "Type Comparison (Soon!)",
    id: "type-comparison",
    enabled: false,
  },
  {
    title: "Type Distribution (Soon!)",
    id: "type-distribution",
    enabled: false,
  },
];
